import { Formik } from 'formik'
import React, { useState } from 'react'
import { Form, Modal } from 'react-bootstrap'
import { useIntl } from 'react-intl'
import { initialValues } from '../../profile/core/_constants'
import { SelectInput } from '../../widgets/components/Input/SelectInput'
import TextInput from '../../widgets/components/Input/TextInput'
import { InfoCard2 } from '../../widgets/components/UI/InfoCard2'
import { ToolTipUIForModal } from '../../widgets/components/UI/ToolTipUIForModal'
import word from '../../../../media/images/word.svg'
import excel from '../../../../media/images/excel.svg'
import deleteIcon from '../../../../media/stakeholders/ic-delete.svg'
import brandingConfig from '../../../../config/brandingConfig'

const AddNewDealModal = ({ isModalActive, setIsModalActive }: any) => {

    const { formatMessage } = useIntl()
    const handleSubmit = async (values: any, { resetForm }: any) => {
    }

    const [files, setFiles] = useState([
        { id: 1, name: 'Foundercrate-featured-image-1.jpg', images: excel },
        { id: 2, name: 'Foundercrate-featured-image-2.jpg', images: excel },
        { id: 3, name: 'Foundercrate-featured-image-3.jpg', images: word },
        { id: 4, name: 'Foundercrate-featured-image-4.jpg', images: word },
        { id: 5, name: 'Foundercrate-featured-image-5.jpg', images: word },
    ])

    const deleteFile = (id: any) => {
        setFiles(files.filter((file) => file.id !== id))
    }

    return (
        <div>
            <Modal
                show={isModalActive}
                onHide={() => {
                    setIsModalActive(false)
                }}
                fullscreen
            >
                <Modal.Header closeButton>
                    <div className="d-flex flex-column">
                        <h2>{formatMessage({ id: 'Add Deals of your Startup' })}</h2>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className='w-100 container'>
                        <InfoCard2
                            title={formatMessage({ id: 'Ready to Showcase Your Startup?' })}
                            desc={formatMessage({ id: 'Publish your startup to join the contest and gather votes from your audience. Share your vision, impress the crowd, and earn the most votes to win.' })}
                            slug={brandingConfig.helpLinks.startupShowcaseAddDeal}
                            className='w-100 mb-0'
                        />
                        <Formik
                            initialValues={initialValues}
                            validationSchema={{}}
                            onSubmit={handleSubmit}
                        >
                            {(formik) => (
                                <Form>
                                    <div className='row'>
                                        <div className='d-flex flex-column'>
                                            <label className='font-size-16 fw-bold'>{formatMessage({ id: 'Deal and Offer' })}<span><ToolTipUIForModal tooltipText={formatMessage({ id: 'Check the box below if you want to list this deal on Founder Market as well.' })} />
                                            </span></label>
                                            <TextInput
                                                fieldName={'communication.email'}
                                                formik={formik}
                                                customText={formatMessage({ id: 'I would also like to add this offer to Foundercrate’s Founder Market Listing' })}
                                                placeholder=''
                                                fieldType={'checkbox'}
                                                isCheckbox={true}
                                                isTooltipNotRequired={true}
                                                margin={'me-20 pe-15'}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='text'
                                                label={formatMessage({ id: 'What is the offer?' })}
                                                fieldName='Offer'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Offer' })}
                                                toolTipText={formatMessage({
                                                    id: 'Enter the offer name here.',
                                                })}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='text'
                                                label={formatMessage({ id: 'Description' })}
                                                fieldName='Description'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Description' })}
                                                toolTipText={formatMessage({
                                                    id: `Describe the offer for your audiences' better understanding of the deal.`,
                                                })}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='number'
                                                label={formatMessage({ id: 'Promo code' })}
                                                fieldName='ExitValue'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter Promo code' })}
                                                toolTipText={formatMessage({
                                                    id: 'Provide Promo Code of the deal that will be displayed on the deal page.',
                                                })}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <SelectInput
                                                label={formatMessage({ id: 'Expiration Date*' })}
                                                fieldName='Currency'
                                                placeholder={formatMessage({
                                                    id: 'Select Date',
                                                })}
                                                formik={formik}
                                                toolTipText={formatMessage({
                                                    id: 'Provide an expiration date for this offer.',
                                                })}
                                                options={[]}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='col-md-6 col-12'>
                                            <TextInput
                                                fieldType='text'
                                                label={formatMessage({ id: 'Claim Offer URL' })}
                                                fieldName='NonConvertibleDebt'
                                                formik={formik}
                                                placeholder={formatMessage({ id: 'Enter URL' })}
                                                toolTipText={formatMessage({
                                                    id: 'Provide the offer URL here that will be used to claim the deal.',
                                                })}
                                                isStarRequired={true}
                                                isTooltipForModal={true}
                                            />
                                        </div>
                                        <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                            {formatMessage({ id: 'Upload Images' })}
                                            <ToolTipUIForModal tooltipText={formatMessage({ id: 'Upload deal images to be used to be used on the deals page.' })} />
                                        </div>
                                        <div className='w-100'>
                                            <button className='btn btn-primary border border-1 mb-4 px-6 py-4 text-center w-md-auto w-100'>
                                                {formatMessage({ id: 'Upload Images' })}
                                            </button>
                                            <p className='text-muted'>{formatMessage({
                                                id: `Recommended size: 400x225
                                                JPG, PNG, GIF.Max size: 2MB`})}</p>
                                        </div>
                                        <div className='mb-4'>
                                            <div className='d-flex form-label  text-dark font-size-13 mt-4'>
                                                {formatMessage({ id: 'Uploaded Files' })}
                                                <ToolTipUIForModal tooltipText={formatMessage({
                                                    id: 'Manage uploaded files here.'
                                                })} />
                                            </div>
                                            <div className='w-100'>
                                                <ul className='p-0 m-0'>
                                                    {files.map((file) => (
                                                        <li
                                                            key={file.id}
                                                            className='d-flex align-items-center gap-2 text-decoration-none mb-2'
                                                        >
                                                            <img src={file.images} alt='' />
                                                            <p className='p-0 m-0'>{file.name}</p>
                                                            <button
                                                                className='btn btn-secondry p-0 m-0'
                                                                onClick={() => deleteFile(file.id)}
                                                            >
                                                                <img src={deleteIcon} alt='Delete' />
                                                            </button>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </div>
                </Modal.Body>
                <Modal.Footer className='container px-0'>
                    <div className='d-md-flex w-100 w-md-auto justify-content-end gap-3'>
                        <div className='w-100 order-1 order-md-2 mb-2 mb-md-auto'>
                            <button type='submit' className=' btn bg-primary text-white custom-button-property w-100'>
                                {formatMessage({ id: 'Submit' })}
                            </button>
                        </div>
                        <div className='w-100 w-md-auto order-2 order-md-1 '>
                            <button type='button' className='btn bg-light custom-button-property text-muted w-100'>
                                {formatMessage({ id: 'Cancel' })}
                            </button>
                        </div>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default AddNewDealModal
